import { Alert } from "antd";
import React, { FC } from "react";
import _t from "../lang/translate";
import { LinkType, ParamTypes, RelatedCasesType } from "../types/appTypes";
import { isValidNum } from "../utilities/typeGuard";
import ServerLink from "./serverLink";
import { useParams } from "react-router-dom";
import { safeNum } from "../utilities/number";

interface ConflictAlertProps {
  conflictedCases: RelatedCasesType;
}

const ConflictAlert: FC<ConflictAlertProps> = ({ conflictedCases }) => {
  const { id } = useParams<ParamTypes>();
  const hasConflictedCasesVin = !!conflictedCases.vin;
  const hasConflictedCasesInfo = !!conflictedCases.info;
  const hasConflictedCasesLink = !!conflictedCases.link;
  const acceptedCases = conflictedCases?.accepted?.filter(item => safeNum(item?.params?.[0]) !== safeNum(id))
  const hasAcceptedCases = !!acceptedCases?.length;

  const descriptionAcceptedCases = hasAcceptedCases ? (
    <p className="mb-0 text-large">
      <strong>{_t("conflicted_cases_accepted_vin")}</strong>&nbsp;
      {acceptedCases?.sort(sortLinkType).map((link, index) => (
        <span key={link.id}>
          <ServerLink link={link} target="_blank" />
          {acceptedCases?.length !== index + 1 ? ", " : ""}
        </span>
      ))}
    </p>
  ) : null;

  const descriptionSameVin = hasConflictedCasesVin ? (
    <p className="mb-0">
      <strong>{_t("conflicted_cases_vin")}</strong>&nbsp;
      {conflictedCases.vin?.sort(sortLinkType).map((link, index) => (
        <span key={link.id}>
          <ServerLink link={link} target="_blank" />
          {conflictedCases.vin?.length !== index + 1 ? ", " : ""}
        </span>
      ))
      }
    </p>
  ) : null;

  const descriptionSameInfo = hasConflictedCasesInfo ? (
    <p className="mb-0">
      {_t("conflicted_cases_info")}&nbsp;
      {conflictedCases.info?.sort(sortLinkType).map((link, index) => (
        <span key={link.id}>
          <ServerLink link={link} target="_blank" />
          {conflictedCases.info?.length !== index + 1 ? ", " : ""}
        </span>
      ))}
    </p>
  ) : null;

  const descriptionSameLink = hasConflictedCasesLink ? (
    <p className="mb-0">
      {_t("conflicted_cases_link")}&nbsp;
      {conflictedCases.link?.sort(sortLinkType).map((link, index) => (
        <span key={link.id}>
          <ServerLink link={link} target="_blank" />
          {conflictedCases.link?.length !== index + 1 ? ", " : ""}
        </span>
      ))}
    </p>
  ) : null;

  const description = (
    <>
      {descriptionAcceptedCases}
      {descriptionSameVin}
      {descriptionSameInfo}
      {descriptionSameLink}
    </>
  );

  if (
    hasConflictedCasesVin ||
    hasConflictedCasesInfo ||
    hasConflictedCasesLink ||
    hasAcceptedCases
  ) {
    return (
      <Alert
        message={description}
        type="error"
        className="mb-1"
        showIcon
        closable
      />
    );
  }

  return null;
};

export default ConflictAlert;


function sortLinkType(a: LinkType, b: LinkType) {
  if (typeof a.params === 'undefined' ||
    typeof b.params === 'undefined' ||
    !a.params?.[0] ||
    !b.params?.[0]
  ) {
    return 1;
  }

  if (typeof a.params[0] === 'string' && typeof b.params[0] === 'string') {
    return a.params[0] < b.params[0]
      ? -1
      : 1;
  }

  if (isValidNum(a.params?.[0]) && isValidNum(b.params?.[0])) {
    return a.params[0] - b.params[0]
  }

  return 0;

}
